import { useState } from 'react';
import { useHistory } from 'react-router';
import { ASSIST_SEARCH } from '@shared/helpers/routes';
import { useDispatch } from 'react-redux';
import {
  saveSearchAssistDetails,
  setFormNoViaja,
  setFormPassengers,
  setFormContact,
} from '@shared/redux/actions';

import Steps from '@shared/components/Steps/steps';
import { ConfirmDialogModal } from '@shared/components/Dialogs';

const ContentSteps = ({ searchData }) => {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <Steps
        searchData={searchData}
        setShowModal={setShowModal}
        activeStep={2}
      />
      <ConfirmDialogModal
        isOpen={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
        onConfirm={() => {
          history.push({
            pathname: `${ASSIST_SEARCH}`,
            state: { goBack: true },
          });
          dispatch(saveSearchAssistDetails(searchData));
          dispatch(setFormPassengers({ pasajeros: null }));
          dispatch(setFormNoViaja({ noViaja: null }));
          dispatch(setFormContact({ contact: null }));
          setShowModal(false);
        }}
        text="¿Estás seguro de salir? Se borrarán los datos cargados."
      />
    </>
  );
};
export default ContentSteps;
